import React from "react";

export default function CutLine() {
  return <div className="t4-cutline" />;
}